import React, { useState } from 'react'
import log from './log.module.css'
import imgI from '../../../img/logo 1.png'
import { Link, useNavigate } from 'react-router'
import { loginAdmin } from '../../../Api/PostManApi'
const Login = () => {
    const [email, setEmail] = useState('')
    const [pass, setPass] = useState('')
      const [modal, setModal] = useState(false);
    const [code , setCode] = useState(new Array(4).fill(" "))

      const toggleModal = () => {
        setModal(!modal);
      };

      const handle = (e, index) => {
        if (isNaN(e.target.value)) return;
        
        setCode(code.map((data, indx) => (indx === index ? e.target.value : data)));
    
        if (e.target.value && e.target.nextElementSibling) {
          e.target.nextElementSibling.focus();
        }
      };
      
      const [error, setError] = useState('');
      const navigate = useNavigate();
  
      const handleSubmit = async (e) => {
          e.preventDefault();
          setError('');
  
          try {
              const data = await loginAdmin(email, pass);
              localStorage.setItem('token', data.token);
              navigate('/ReviewerII'); // Redirect after successful login
          } catch (error) {
              setError(error.message);
          }
      };

  return (


    <div className={log.log}>
       <div className={log.container}>
        <div className={log.content}>
            <div className={log.logo}>
                <img src={imgI} alt="" />
            </div>
            <div className={log.block}>
                <div className={log.seci}>
                    <h3>Welcome</h3>
                    <p>Register your account to access your dashboard and 
                    modify your dashboard activities</p>
                </div>
                <form action="/" onSubmit={handleSubmit}>
                    <div className={log.email}>
                        <label htmlFor="">email</label>
                        <input 
                        type="email" 
                        name="email" 
                        value={email}  id="email"
                        placeholder='Enter your Email' 
                        onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className={log.pass}>
                        <label htmlFor="">Password</label>
                        <input 
                        type="password" 
                        name="pass" id="pass" 
                        value={pass} 
                        onChange={(e) => setPass(e.target.value)}/>
                    </div>
                    <div className={log.secii}>
                        <p>Register your account to access your dashboard and 
                        modify your dashboard activities</p>
                        <Link onClick={toggleModal}> Forget Password</Link>
                        <button className={log.btni} type="submit">Sign In</button>

                        {modal && (
                                <div className="modal">
                                    <div className={log.overlay}></div>
                                    {/* onClick={toggleModal} */}
                                        <div className={log.modalcontent} >
                                            <div className={log.flex}>
                                                <h3>Code Verification</h3>
                                                <p>A code has been sent to your email daviddamilej568@gmail.com, please 
                                                input it in the box to verify your mail</p>
                                            </div>
                                            <div className={log.code}>
                                            {Array.isArray(code) &&
                                                code.map((data, i) => (
                                                <input key={i} type="text"
                                                value={data}
                                                // maxLength={1}
                                                 onChange={(e)=> handle(e, i)}
                                                 />
                                            ))}
                                            </div>
                                
                                            <button className={log.btn} >
                                                Resend verification code
                                            </button>
                                            <Link to='/Reviewer/ForgetPage'>
                                            <button className={log.closemodal} >
                                                Next
                                            </button>
                                            </Link>
                                        </div>
                                </div>
                             )}

                    </div>
                </form>
            </div>
        </div>
       </div>
    </div>
  )
}

export default Login
